/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AnonymousHostnameForParentEntityIdGet$Params {
  parentEntityId?: string;
}

export function anonymousHostnameForParentEntityIdGet(http: HttpClient, rootUrl: string, params?: AnonymousHostnameForParentEntityIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, anonymousHostnameForParentEntityIdGet.PATH, 'get');
  if (params) {
    rb.query('parentEntityId', params.parentEntityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<string>;
    })
  );
}

anonymousHostnameForParentEntityIdGet.PATH = '/Anonymous/HostnameForParentEntityId';
